import Image from 'components/NewsImage';
import Link from 'components/Link';
import { getNewsPostPage, NEWS_INDEX_PAGE } from 'constants/pages';

interface Post {
  _id: string;
  title: string;
  slug?: string;
  featuredImageUrl?: string;
  seoMeta?: {
    metaDescription?: string;
  };
}

interface YouMayLikeSectionProps {
  heading: string;
  data: Post[];
}

const YouMayLikeSection = ({ heading, data }: YouMayLikeSectionProps) => {
  return (
    <div className="w-full">
      <h3 className="py-4 text-center text-2xl font-semibold text-white sm:py-6 sm:text-3xl md:text-4xl">
        {heading}
      </h3>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {data.map((item) => {
          return (
            <div key={item._id} className="relative flex items-start space-x-3 px-6 py-2 md:py-5">
              <div className="flex-shrink-0">
                <div className="relative h-16 w-24 overflow-hidden rounded-lg">
                  <Image
                    src={item.featuredImageUrl || '/placeholder.svg'}
                    alt={item.title}
                    width={96}
                    height={64}
                    loading="lazy"
                    className="rounded-lg object-cover"
                  />
                </div>
              </div>
              <div className="min-w-0 flex-1 items-start align-top">
                <Link href={getNewsPostPage(item.slug || '')}>
                  <span className="absolute inset-0" aria-hidden="true" />
                  <p className="text-sm font-medium text-white">{item.title}</p>
                </Link>
                <p className="text-xs text-gray-400">{item.seoMeta?.metaDescription || ''}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex justify-center py-10">
        <Link
          href={NEWS_INDEX_PAGE}
          className="text-primary rounded bg-brand-primary px-5 py-3 text-base font-semibold hover:bg-white hover:text-brand-primary"
        >
          View All Stories
        </Link>
      </div>
    </div>
  );
};

export default YouMayLikeSection;
